import { render, staticRenderFns } from "./RevenueView.vue?vue&type=template&id=6b39aa23"
import script from "./RevenueView.vue?vue&type=script&lang=js"
export * from "./RevenueView.vue?vue&type=script&lang=js"
import style0 from "./RevenueView.vue?vue&type=style&index=0&id=6b39aa23&prod&lang=css"
import style1 from "./RevenueView.vue?vue&type=style&index=1&id=6b39aa23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports